<template>
  <div class="bg-gray-200 pt-2" :id="currentRouteId">
    <div class="container mx-auto">
      <div
        class="flex-initial flex items-center justify-around mx-auto text-sm"
      >
        <div class="flex-1 text-left">
          <p v-show="branchLocation" class="">
            <svg
              width="15"
              height="15"
              viewBox="0 0 22 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="inline-block icon-location"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.0489 15.0653C8.60126 15.0653 6.61722 13.125 6.61722 10.7314C6.61722 8.33776 8.60126 6.39751 11.0489 6.39751C13.4962 6.39751 15.4806 8.33776 15.4806 10.7314C15.4806 13.125 13.4962 15.0653 11.0489 15.0653ZM21.9782 10.4774L21.8538 9.44257L21.6274 8.42411L21.3012 7.43165L20.8781 6.47453L20.3627 5.56242L19.7589 4.70297L19.0737 3.90454L18.3121 3.17478L17.482 2.52103L16.5906 1.94796L15.648 1.4629L14.6608 1.06885L13.6401 0.770145L12.5939 0.56912L11.5327 0.467773H10.4667L9.40612 0.56912L8.3599 0.770145L7.3389 1.06885L6.35199 1.4629L5.40872 1.94796L4.51795 2.52103L3.68786 3.17478L2.92629 3.90454L2.24074 4.70297L1.63734 5.56242L1.12122 6.47453L0.698846 7.43165L0.372604 8.42411L0.146246 9.44257L0.0218176 10.4774L0 11.5198L0.0818161 12.559L0.265902 13.5861L0.550554 14.5909L0.933385 15.5637L1.41099 16.4958L1.97824 17.3779L2.63039 18.2027L10.9998 27.7916L19.3696 18.2027L20.0218 17.3779L20.589 16.4958L21.0663 15.5637L21.4491 14.5909L21.7338 13.5861L21.9178 12.559L22 11.5198L21.9782 10.4774Z"
                fill="#5BB35E"
              />
              <mask
                id="mask0"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="22"
                height="28"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.0489 15.0653C8.60126 15.0653 6.61722 13.125 6.61722 10.7314C6.61722 8.33776 8.60126 6.39751 11.0489 6.39751C13.4962 6.39751 15.4806 8.33776 15.4806 10.7314C15.4806 13.125 13.4962 15.0653 11.0489 15.0653ZM21.9782 10.4774L21.8538 9.44257L21.6274 8.42411L21.3012 7.43165L20.8781 6.47453L20.3627 5.56242L19.7589 4.70297L19.0737 3.90454L18.3121 3.17478L17.482 2.52103L16.5906 1.94796L15.648 1.4629L14.6608 1.06885L13.6401 0.770145L12.5939 0.56912L11.5327 0.467773H10.4667L9.40612 0.56912L8.3599 0.770145L7.3389 1.06885L6.35199 1.4629L5.40872 1.94796L4.51795 2.52103L3.68786 3.17478L2.92629 3.90454L2.24074 4.70297L1.63734 5.56242L1.12122 6.47453L0.698846 7.43165L0.372604 8.42411L0.146246 9.44257L0.0218176 10.4774L0 11.5198L0.0818161 12.559L0.265902 13.5861L0.550554 14.5909L0.933385 15.5637L1.41099 16.4958L1.97824 17.3779L2.63039 18.2027L10.9998 27.7916L19.3696 18.2027L20.0218 17.3779L20.589 16.4958L21.0663 15.5637L21.4491 14.5909L21.7338 13.5861L21.9178 12.559L22 11.5198L21.9782 10.4774Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0)"></g>
            </svg>

            Proudly Serving
            <ClientOnly>
              <span class="font-semibold uppercase">{{ branchLocation }}</span>
            </ClientOnly>
            &#183;
            <a
              v-if="!isCartOrCheckoutPage"
              href="#"
              @click="addressModal?.show?.()"
              class="font-bold change-address"
            >
              Change
            </a>
          </p>
        </div>
        <div
          class="flex-1 text-green-600 font-extrabold text-center cart-hidden"
        >
          <p class="">
            <a href="#" @click="ndcModal?.show?.()" class="discount-link">
              Did you receive a mail or email code?
            </a>
          </p>
        </div>
        <div class="flex-1 text-right">
          <p class="text-green-600 font-bold">
            <NuxtLink
              to="/about-us/contact-spring-green/"
              class="cart-hidden block md:inline"
              >Contact Us</NuxtLink
            >
            <ClientOnly>
              <a
                class="text-gray-500 font-bold ml-2"
                v-show="branchPhone"
                v-bind:href="branchPhoneHref"
              >
                {{ formattedBranchPhone }}
              </a>
            </ClientOnly>
          </p>
        </div>
      </div>
    </div>
    <AddressModal ref="addressModal" />
    <NdcModal ref="ndcModal" />
  </div>
</template>

<script setup lang="ts">
import { useStore } from "vuex";
import type { Store } from "vuex/types/index.js";
import type State from "~/domains/store/State";
import { formatPhoneNumber, getPhoneHref } from "~/utils/phone";

const addressModal = useTemplateRef("addressModal");
const ndcModal = useTemplateRef("ndcModal");

const store: Store<State> = useStore();
const router = useRouter();

const currentPath = computed(() => router.currentRoute.value.path ?? "");
const currentRouteId = computed(() => String(router.currentRoute.value.name ?? ""));

const isCartOrCheckoutPage = computed(() => {
  const path = currentPath.value;
  return (
    path === "/cart" ||
    path.startsWith("/cart/") ||
    path === "/checkout" ||
    path.startsWith("/checkout/")
  );
});

// Computed properties
const branchLocation = computed(
  () => store.state.persistedState.branchLocation
);
const branchPhone = computed(
  () => store.state.persistedState.branchPhone?.FieldValue
);
const formattedBranchPhone = computed(
  () => formatPhoneNumber(branchPhone.value) ?? branchPhone.value,
);
const branchPhoneHref = computed(() => getPhoneHref(branchPhone.value) ?? undefined);

// Lifecycle hooks
onMounted(() => {

});
</script>

<style scoped>
button {
  background-color: #00810e;
}

input[type="text"] {
  border: 0 solid;
  margin-top: 0;
  margin-bottom: 0;
  color: #517185;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #517185;
  opacity: 0.9; /* Firefox */
}
:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #517185;
}
::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #517185;
}

form {
  border-radius: 100px;
  border: 1px solid #ccc;
}

h1 {
  margin: 0;
  color: #517185;
}

@media (max-width: 640px) {
  .icon-location {
    width: 15px;
    height: 15px;
  }

  p {
    font-size: 12px;
    line-height: 1.2;
  }
}
</style>
